import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTimes } from '@fortawesome/free-solid-svg-icons';

const Uploadgenrate = ({ isOpen, onClose, onSubmit }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        // Safeguard: Check if event and target exist
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            toast.warning('No file selected or invalid event.');
            return;
        }

        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
        //  toast.success(`File "${file.name}" selected`);
        } else {
            setSelectedFile(null);
        }
    };

    const handleDownloadTemplate = () => {
        // Template file URL 
        const templateUrl = 'publicsample_BillingData.csv'; 
        
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = templateUrl;
        link.download = 'sample_BillingData.csv'; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        toast.success('Template downloaded successfully!');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (!selectedFile) {
            toast.error('Please upload a file');
            return;
        }

        // Call parent submit function (only pass file)
        onSubmit({ file: selectedFile });
        
        // Reset form
        resetForm();
    };

    const resetForm = () => {
        setSelectedFile(null);
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 flex justify-center items-center p-4"
            onClick={handleClose}
        >
            <div
                className="bg-white rounded-lg shadow-xl w-full max-w-md relative"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>

                {/* Modal Content */}
                <div className="p-6">
                    <h2 className="text-lg font-medium text-gray-800 mb-4">
                        Genrate file
                    </h2>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {/* Instructions & Download Template - Compact */}
                        <div className="bg-gray-50 p-3 rounded border border-gray-200">
            
                        <div style={{ textAlign: 'center', maxWidth: '28rem', padding: '1rem' }}>
    
                            <p>
                                <span style={{ fontWeight: 'bold', fontSize: '1.125rem' }}>Instructions</span> <br/>
                                Please download the template, fill in the required details, and upload the completed file using the form.
                            </p>
                            <button
                                type="button"
    
                                onClick={handleDownloadTemplate}
                                className="w-full px-4 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 text-xs font-medium transition-colors"
                            >
                                Download Template
                            </button>
                            
                            </div>
                        </div>

                        {/* Upload File */}
                        <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1.5">
                                Select File <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="file"
                                onChange={handleFileChange}
                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.csv"
                                multiple={false}
                                className="w-full px-2 py-1.5 border border-gray-300 rounded bg-white text-xs cursor-pointer file:mr-2 file:py-1 file:px-3 file:rounded file:border-0 file:bg-gray-100 file:text-gray-700 file:text-xs file:cursor-pointer file:hover:bg-gray-200"
                            />
                            {selectedFile && (
                                <p className="mt-1 text-xs text-gray-600">
                                    ✓ {selectedFile.name}
                                </p>
                            )}
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-2 pt-1">
                            <button
                                type="button"
                                onClick={handleClose}
                                className="px-4 py-1.5 bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-50 text-xs font-medium transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 text-xs font-medium transition-colors"
                            >
                                Upload
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Uploadgenrate;